/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Topic({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor"><path d="M5.518 1.112a.6.6 0 0 1 0 1.2H1.6a.6.6 0 0 1 0-1.2zM6.557 4.112a.6.6 0 0 1 0 1.2H1.6a.6.6 0 0 1 0-1.2zM3.64 7.112a.6.6 0 0 1 0 1.2H1.6a.6.6 0 0 1 0-1.2zM14.141 3.601a1.55 1.55 0 0 1 1.54 1.564l-.03 3.662a1.55 1.55 0 0 1-.454 1.084l-5.291 5.292a1.55 1.55 0 0 1-2.196 0l-3.695-3.695a1.55 1.55 0 0 1 0-2.196l5.286-5.285.114-.103a1.55 1.55 0 0 1 .996-.35zm-9.206 6.882q.015.035.042.062l3.695 3.696a.2.2 0 0 0 .136.057.2.2 0 0 0 .135-.057l5.292-5.292a.2.2 0 0 0 .056-.134l.029-3.66a.19.19 0 0 0-.117-.179.2.2 0 0 0-.073-.014l-3.73-.03a.2.2 0 0 0-.137.057l-5.286 5.285a.2.2 0 0 0-.057.136q0 .038.015.073" /><path d="M12.5 6.669a1.02 1.02 0 0 1 .018 1.463 1.023 1.023 0 1 1-.018-1.463" /></g></svg>;
}
;